import { securedAxios } from "../lib/axios";

export default {
  namespaced: true,
  mutations: {},
  actions: {
    async gravar(context, contasPagarInfo) {
      try {
        let response;
        if (contasPagarInfo.id == "") {
          delete contasPagarInfo.id;
          response = await securedAxios.post("/contaspagar", contasPagarInfo);
        } else {
          var id = contasPagarInfo.id;
          delete contasPagarInfo.id;
          response = await securedAxios.put(
            "/contaspagar/" + id,
            contasPagarInfo
          );
        }

        return Promise.resolve(response.data);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async deletarPorFatura(context, id_fatura) {
      try {
        const response = securedAxios.delete(`/cp/origem/FAT/${id_fatura}`);
        return Promise.resolve(response);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async deletarPorNota(context, id_nfs) {
      try {
        const response = securedAxios.delete(`/cp/origem/NFS/${id_nfs}`);
        return Promise.resolve(response);
      } catch (err) {
        return Promise.reject(err);
      }
    }
  }
};
